export const TABLET_MAX_SEATS = 51;
export const MOBILE_MAX_SEATS = 43;
export const TABLET_NEW_MAX_SEATS = 66;
export const MOBILE_NEW_MAX_SEATS = 60;
export const GRID_COLUMNS_TABLET = 12;
export const GRID_COLUMNS_MOBILE = 8;

export const TOP_ROW = 3;
export const SECOND_THIRD_ROW_DESKTOP = 6;
export const SECOND_THIRD_ROW_MOBILE = 4;

export const DEFAULT_TABLET_SEAT_COUNT = 39;
export const DEFAULT_MOBILE_SEAT_COUNT = 27;

export const TABLET_SIZE = 768;

export const DESKTOP_FIRST_MAX_IMAGE_SIZE = 245;
export const DESKTOP_MID_MAX_IMAGE_SIZE = 117;
export const DESKTOP_LAST_MAX_IMAGE_SIZE = 53;

export const TABLET_FIRST_MAX_IMAGE_SIZE = 358;
export const TABLET_MID_MAX_IMAGE_SIZE = 173;
export const TABLET_LAST_MAX_IMAGE_SIZE = 80;

// V2 numbers
export const SECOND_THIRD_ROW_DESKTOP_V2 = 9;
export const SECOND_THIRD_ROW_MOBILE_V2 = 4;

export const SECOND_THIRD_ROW_DESKTOP_EMPTY_V2 = 3;
export const SECOND_THIRD_ROW_MOBILE_EMPTY_V2 = 4;

export const DEFAULT_TABLET_EMPTY_SEAT_COUNT_V2 = 18;
export const DEFAULT_MOBILE_EMPTY_SEAT_COUNT_V2 = 21;

export const TABLET_MAX_SEATS_V2 = 48;
export const MOBILE_MAX_SEATS_V2 = 45;
